import React, { useState } from 'react';
import { useEffect } from 'react';
import Selector from './Selector';
import { getReports } from '../utils';
import Result from './Result';
import LearningCurveResult from './LearningCurveResult';
import ReportNavBar from './ReportNavBar';
function Report(props) {
  const [frequency, setFrequency] = useState("WEEK");
  const [numberOfWindows, setNumberOfWindows] = useState(5);
  const [data, setData] = useState([]);
  const [type, setType] = useState("organizer");


  //TODO Terrible code!! Have to change this arggh...
  useEffect(() => {
    document.title = 'Report'
    setData([]) 
    getReports(frequency,numberOfWindows,type)
    .then((response)=>{
      let weeklyData =[]
      if(type ==="organizer")
        weeklyData = response?.data?.organizer?.weekly
      else if(type==="learning")  
       weeklyData = response?.data?.learning?.weekly
      if(weeklyData){
        for(var counter=0;counter<weeklyData.length;counter++){
          weeklyData[counter].startDateQueryParam=weeklyData[counter].startDate;
          weeklyData[counter].endDateQueryParam=weeklyData[counter].endDate;
          if(counter<weeklyData.length-1 ){
            weeklyData[counter].previousResult=weeklyData[counter+1]
          }
          weeklyData[counter].type=type
        }
        setData(weeklyData)
      }
 
      
    
    }).catch((error)=>{console.log(error)})
    //var date = new Date();
      //var day = date.getDay(),
      //diff = date.getDate() - day + (day === 0 ? -6:1); // adjust when day is sunday
     // var startDate =  new Date(date.setDate(diff));
      //var previousReport = 
/*
      var endDate = new Date()
      var day = endDate.getDay(),
      diff = endDate.getDate() + (7-day) + (day === 0 ? -7:0); // adjust when day is sunday
      endDate= new Date(endDate.setDate(diff));
      var dateRanges=[]
    for(var window=0;window<numberOfWindows;window++){
     // startDate =  new Date(date.setDate(diff));
     var endDateClone = new Date(endDate)
     //var day = endDate.getDay(),
     //diff = endDate.getDate() - day + (day === 0 ? -6:1); // adjust when day is sunday
     var startDate =  new Date(endDateClone.setDate(endDateClone.getDate() -6));
     dateRanges.push({
      startDate:new Date(startDate),
      endDate:new Date(endDate)
     })
endDate = startDate;
endDate.setDate(startDate.getDate()-1); 
    }
    const retrieveDataForAll= async (arr)=> {
      for(var dateRangeCounter=numberOfWindows-1;dateRangeCounter>=0;dateRangeCounter--){
      startDate = dateRanges[dateRangeCounter].startDate
      endDate = dateRanges[dateRangeCounter].endDate

      const getMonthName=function (monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber - 1);
      
        return date.toLocaleString('en-US', {
          month: 'long',
        });
      }

      const format = function(date){
        return ("0" + date.getDate()).slice(-2) + "-" + getMonthName(date.getMonth()+1)
      }
      let response = await getReports(startDate.toISOString().split('T')[0],endDate.toISOString().split('T')[0],type);
      if(response){
        if(type==='organizer2'){
          startDate = new Date(Date.parse(response.startDateQueryParam))
          let startDateQueryParam=format(startDate);
          endDate = new Date(Date.parse(response.endDateQueryParam));
          let endDateQueryParam=format(endDate);
          response.startDateQueryParam=startDateQueryParam;
          response.endDateQueryParam=endDateQueryParam;
        }else{
          response.startDateQueryParam=startDate.toISOString().split('T')[0];
          response.endDateQueryParam=endDate.toISOString().split('T')[0];
        }
        
      }
      arr.push(response)
      }
      for(var arrCounter=arr.length-1;arrCounter>0;arrCounter--){
        arr[arrCounter].previousResult = arr[arrCounter-1]
      }
      setData(arr.reverse()) ;
    }
  var arr =[]
  
  retrieveDataForAll(arr)
*/
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[frequency,numberOfWindows,type])

return(
  <>
  <ReportNavBar></ReportNavBar>
  <Selector type={type} setType={setType} numberOfWindows={numberOfWindows} onWindowNumberChange={setNumberOfWindows}  frequency={frequency} onFrequencyChange={setFrequency}></Selector>
  {type==='organizer'  && <Result data={data}></Result>}
  {type==='learning'  && <LearningCurveResult data={data}></LearningCurveResult>}
  </>
)
}
export default Report